// src/i18n/en/dispensers.ts
// «Dispensadores» — route /dispensers, Dirección. The production dashboard's
// dispenser block as its own screen.
export const dispensers = {
  name: 'Dispensers |||| Dispensers',
  subtitle: 'Key delivery at the dispensers of your properties',

  tiles: {
    keysDelivered: 'Keys delivered',
    keysDeliveredDetail: 'In the period',
    successRate: 'Successful deliveries',
    successRateDetail: '%{delivered} of %{attempts} attempts ended with the key delivered',
    noAttempts: 'No delivery attempts in the period',
    activeDispensers: 'Active dispensers',
    activeDispensersDetail: 'With any event in the period, of those registered and not withdrawn',
    failed: 'Failed deliveries',
    failedDetail: 'Attempts that did not end with the key delivered, whatever the cause',
  },

  byDay: {
    title: 'Keys delivered and failed deliveries per day',
    series: { keysDispensed: 'Keys delivered', errors: 'Failed deliveries' },
  },

  byHotel: {
    title: 'By property',
    description: 'Every property with a delivery attempt in the period, most keys delivered first.',
    empty: 'No delivery attempts in the period.',
    columns: {
      hotel: 'Property',
      keysDispensed: 'Delivered',
      errors: 'Failed deliveries',
      successRate: '% successful',
      dispenserCount: 'Registered dispensers',
    },
  },

  errorTypes: {
    title: 'Errors by type',
    description: 'Each error of the period and in how many failed deliveries it was; an attempt with two causes counts in both.',
    empty: 'No errors in the period.',
    columns: {
      type: 'Type',
      count: 'Errors',
      failed: 'Failed deliveries',
    },
  },

  noDispensers: {
    title: 'There are no dispensers at the selected properties',
    description: 'Choose other properties or see key delivery in Channels.',
  },

  errorCodes: {
    NO_CODE: 'No error code',
    MECH_JAM: 'Mechanical jam',
    OUT_OF_KEYS: 'Out of cards',
    SENSOR_ERROR: 'Sensor error',
    TIMEOUT: 'Timed out',
    DOOR_OPEN: 'Door open',
    QR_READ_ERROR: 'QR read error',
    QR_SIGNATURE: 'Invalid QR signature',
    QR_IS_EXPIRED: 'QR expired',
    QR_FORMAT: 'Invalid QR format',
    CARD_TIMEOUT_RW_POSITION: 'Timed out at the read position',
    CARD_TIMEOUT_BEZEL: 'Timed out at the card exit',
    CARD_HOPPER_EMPTY: 'Card hopper empty',
    CARD_HOPPER_LOW: 'Few cards left',
    CARD_FEEDED_FROM_FRONT: 'Card inserted from the front',
    CARD_NOT_PICKED_UP: 'Card not collected',
    CARD_WRITE_FAILED: 'Card write failed',
    CARD_READ_FAILED: 'Card read failed',
    MAX_CARDS_REACHED: 'Maximum cards reached',
    RFID_ENCODER_NOT_FOUND: 'Card encoder not found',
    KD_REBOOT: 'Dispenser restarted',
    KD_UID_NOT_REGISTERED: 'Card not registered',
    KD_DIGITAL_KEY_DELIVERY_FAILED: 'Digital key could not be delivered',
    LOCKS_GENERAL: 'Lock system error',
    LOCKS_TIMEOUT: 'Lock system timed out',
    LOCKS_ENCODER_COMM: 'Encoder communication error',
    LOCKS_COMM: 'Lock system communication error',
    LOCKS_SYNTAX: 'Invalid request to the lock system',
    LOCKS_NO_FILES: 'Lock system files missing',
    LOCKS_OVERFLOW: 'Lock system overflow',
    LOCKS_CARD: 'Lock card error',
    LOCKS_FORMAT: 'Invalid format in the lock system',
    LOCKS_UNKNOWN_ROOM: 'Room not set up in the lock system',
    LOCKS_CHECKED_OUT: 'The stay has already checked out',
    LOCKS_OUT_OF_SERVICE: 'Lock system out of service',
    LOCKS_BUSY: 'Lock system busy',
    LOCKS_VALID_STAFF_CARD: 'Staff card detected',
    LOCKS_CARD_READ_FAILED: 'Lock card read failed',
    LOCKS_CARD_WRITE_FAILED: 'Lock card write failed',
    LOCKS_READ_ERROR: 'Lock system read error',
    NETWORK_TIMEOUT: 'The network did not answer in time',
    NETWORK_DISCONNECTED: 'Network disconnected',
    SYSTEM_ERROR: 'Internal device error',
    PMS_RESERVATION_NOT_FOUND: 'Reservation not found in the hotel system',
    PMS_COMM: 'Hotel system communication error',
    PMS_RECOVERY_FAILED: 'Check-in could not be recovered in the hotel system',
  },

  help: {
    title: 'Dispensers',
    description: 'How many keys the dispensers of your properties delivered, how many deliveries failed and which dispensers were active in the period.',
    features: {
      success: 'An attempt is one guest at one dispenser: the events of the same reservation (or room) at the same dispenser less than 10 minutes apart. It succeeds when any key comes out and fails otherwise, whatever the cause. The percentage is successful attempts over attempts.',
      active: 'A dispenser is active when it sent any signal in the period, even without delivering a key. Withdrawn dispensers do not count. Days are the days of the hotel.',
    },
    tips: {
      errors: 'The errors table also counts errors that did not prevent the delivery (the guest tried again and got the key), so it counts more errors than failed deliveries.',
    },
  },
};

export default dispensers;
